import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=231e8df5&scoped=true&"
import script from "./DeleteUser.vue?vue&type=script&lang=ts&"
export * from "./DeleteUser.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=231e8df5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e8df5",
  null
  
)

export default component.exports